<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
	export default {
		name: 'App',
	}
</script>

<style lang="scss">
	@import '../node_modules/bootstrap/scss/bootstrap';
	@import '../node_modules/bootstrap-vue/src/index.scss';
	@import url('https://fonts.googleapis.com/css2?family=Saira+Condensed:wght@400;500;600&display=swap');
	@import 'assets/css/source.scss';

	#app {
		height: 100%;
	}
</style>
